import { distance } from '@turf/turf';
import createGraph from 'ngraph.graph';
import * as path from 'ngraph.path';
import MapboxRouter from './MapboxRouter';
import RoveRouter from './RoveRouter';
const LAT_LNG_DIGITS = 5;
class GraphRouter {
    constructor(tolerance) {
        this.nodes = [];
        this.graph = createGraph();
        this.tolerance = tolerance || 0.00002;
    }
    addEdge(position1, position2, info) {
        let weight = distance(position1.coordinate, position2.coordinate) * 1000;
        if (position1.floorIndex !== position2.floorIndex) {
            weight = Math.abs(position1.floorIndex - position2.floorIndex) * 5000;
        }
        info.weight = weight;
        const pos1 = this.generateFloorPositionNode(position1);
        const pos2 = this.generateFloorPositionNode(position2);
        if (info.isStairs) {
            const directionMoving = position1.floorIndex > position2.floorIndex ? 'down' : 'up';
            if ((info.direction === 'up' && directionMoving === 'down') || (info.direction === 'down' && directionMoving === 'up')) {
                console.log('not add edge for stairs as moving the incorrect direction');
                return;
            }
            if (info.weight === 0) {
                info.weight = 5;
            }
            if (info.forceConnection) {
                const closestNode = this.findClosestNode(position1, true);
                if (closestNode) {
                    this.addEdge(position1, {
                        coordinate: closestNode.data.position,
                        floorIndex: closestNode.data.floorId
                    }, { isStairs: false });
                }
                const closestNode2 = this.findClosestNode(position2, true);
                if (closestNode2) {
                    this.addEdge(position2, {
                        coordinate: closestNode2.data.position,
                        floorIndex: closestNode2.data.floorId
                    }, { isStairs: false });
                }
            }
            this.graph.addLink(pos1, pos2, info);
        }
        else {
            if (info.weight > 0 && pos1 !== pos2) {
                this.graph.addLink(pos1, pos2, info);
            }
        }
    }
    generateFloorPositionNode(position) {
        const xRounded = this.getRoundedPosition(position.coordinate[0], LAT_LNG_DIGITS);
        const yRounded = this.getRoundedPosition(position.coordinate[1], LAT_LNG_DIGITS);
        const name = `${xRounded}|${yRounded}|${position.floorIndex}`;
        const found = this.nodes.find((node) => node.id === name);
        if (!found) {
            const newNode = this.graph.addNode(name, {
                position: [xRounded, yRounded],
                floorId: position.floorIndex,
            });
            this.nodes.push(newNode);
        }
        return name;
    }
    getRoundedPosition(coordinate, toFixed) {
        return parseFloat((Math.round(coordinate / this.tolerance) * this.tolerance).toFixed(toFixed));
    }
    findRoute(position1, position2, handicapMode) {
        const start = this.findClosestNode(position1);
        const end = this.findClosestNode(position2);
        if (!start || !end) {
            return [];
        }
        const pathFinder = path.aStar(this.graph, {
            blocked(fromNode, toNode, link) {
                if (!link.data.isStairs) {
                    return false;
                }
                const directionMoving = fromNode.data.floorId > toNode.data.floorId ? 'down' : 'up';
                if (directionMoving === 'down' && link.data.direction === 'up') {
                    return true;
                }
                if (directionMoving === 'up' && link.data.direction === 'down') {
                    return true;
                }
                return ((handicapMode && !link.data.handicapAccessible) || (!handicapMode && link.data.handicapOnly));
            }
        });
        const result = pathFinder.find(end.id, start.id);
        let currentFloor = -1;
        let currentPath;
        const paths = [];
        result.forEach((node) => {
            if (node.data.floorId !== currentFloor) {
                if (currentPath && currentPath.Coordinates.length > 0) {
                    paths.push(currentPath);
                }
                currentPath = {
                    FloorIndex: node.data.floorId,
                    Coordinates: [],
                };
                currentFloor = node.data.floorId;
            }
            if (currentPath) {
                currentPath.Coordinates.push(node.data.position);
            }
        });
        if (currentPath && currentPath.Coordinates.length > 0) {
            paths.push(currentPath);
        }
        return paths;
    }
    findClosestNode(position, omitZero = false) {
        let closestNode;
        let closestDistance = 1000000;
        const xRounded = this.getRoundedPosition(position.coordinate[0], LAT_LNG_DIGITS);
        const yRounded = this.getRoundedPosition(position.coordinate[1], LAT_LNG_DIGITS);
        position.coordinate[0] = xRounded;
        position.coordinate[1] = yRounded;
        this.nodes.forEach((node) => {
            if (node.data.floorId !== position.floorIndex) {
                return;
            }
            const nodeDistance = distance(node.data.position, position.coordinate);
            if (nodeDistance < closestDistance && (!omitZero || nodeDistance > 0)) {
                closestNode = node;
                closestDistance = nodeDistance;
            }
        });
        return closestNode;
    }
}
export { GraphRouter, MapboxRouter, RoveRouter };
